/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Import_Required_TextInputs */

const en_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please re-import the media file.`)
};

const fr_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez reimporter le fichier media.`)
};

const de_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte importieren Sie die Mediendatei erneut.`)
};

const it_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimportare il file multimediale.`)
};

const ru_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, повторно импортируйте медиафайл.`)
};

const es_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, vuelva a importar el archivo multimedia.`)
};

const zh_cn2_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请重新导入媒体文件。`)
};

const ja_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルを再度インポートしてください。`)
};

const hi_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया मीडिया फ़ाइल को पुनः आयात करें।`)
};

const pt_pt2_load_project_file_media_import_required_text = /** @type {(inputs: Load_Project_File_Media_Import_Required_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, importe o arquivo de mídia novamente.`)
};

/**
* | output |
* | --- |
* | "Please re-import the media file." |
*
* @param {Load_Project_File_Media_Import_Required_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_import_required_text = /** @type {((inputs?: Load_Project_File_Media_Import_Required_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Import_Required_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_media_import_required_text(inputs)
	if (locale === "de") return de_load_project_file_media_import_required_text(inputs)
	if (locale === "it") return it_load_project_file_media_import_required_text(inputs)
	if (locale === "ru") return ru_load_project_file_media_import_required_text(inputs)
	if (locale === "es") return es_load_project_file_media_import_required_text(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_media_import_required_text(inputs)
	if (locale === "ja") return ja_load_project_file_media_import_required_text(inputs)
	if (locale === "hi") return hi_load_project_file_media_import_required_text(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_media_import_required_text(inputs)
	return en_load_project_file_media_import_required_text(inputs)
});